export default __webpack_public_path__ + "static/media/alvedon.576b2e4a.png";